import { memo } from "react";
import { Box } from "@mui/material";
import { AppImage } from "@/common";
import { cn } from "@/utils/common.utils";
import clsx from "clsx";

const HeaderLogo = ({ isShowFullMenu }: { isShowFullMenu: boolean }) => {
  return (
    <Box
      className={cn(
        "overflow-hidden mx-auto h-[50px] min-h-[50px] duration-300 mb-3 ",
        isShowFullMenu ? "w-[auto]" : "w-[50px]",
      )}
    >
      <AppImage
        className="object-contain"
        src={"/images/logo.png"}
        width={"220px"}
        height={"50px"}
        alt={"logo"}
        fill={true}
        priority
        boxProps={{
          className: clsx("w-[220px]", {
            relative: !isShowFullMenu,
          }),
          sx: !isShowFullMenu
            ? {
                transform: "translateX(-30px)",
              }
            : {},
        }}
      />
    </Box>
  );
};

export default memo(HeaderLogo);
